import axios from "axios";
import { WEBCHAT_CONFIG, CHAT_AUTH_TOKEN } from "../components/webchatConfig";

const API_BASE_URL = "https://chat.versalence.info/interactions/infinium";

export const getUserBasedQuestions = async (userId) => {
    try {
        const uuid = WEBCHAT_CONFIG.uuid;

        const url = `${API_BASE_URL}/getUserBasedQuestions/${uuid}/${userId}`;

        const response = await axios.get(url, {
            headers: {
                "Authorization": `Bearer ${CHAT_AUTH_TOKEN}`,
                "Content-Type": "application/json"
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        console.error("Error fetching user questions:", error);
        return {
            success: false,
            error: error.response?.data?.message || error.message
        };
    }
};
